import {
  Button,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { FiBox, FiChevronDown, FiUser } from "react-icons/fi";
import { InternalLink } from "components/Link";
import { SHARED_ROUTES } from "definitions/constants/routeConstants";

export type SenderType = "me" | "bot";

const SENDER_OPTIONS: { value: SenderType; label: string; icon: typeof FiUser }[] = [
  { value: "me", label: "From Me", icon: FiUser },
  { value: "bot", label: "From Bot", icon: FiBox },
];

interface SenderToggleProps {
  value: SenderType;
  onChange: (value: SenderType) => void;
  isAuthorized: boolean;
}

export default function SenderToggle({ value, onChange, isAuthorized }: SenderToggleProps) {
  const selected = SENDER_OPTIONS.find((o) => o.value === value) ?? SENDER_OPTIONS[0];

  return (
    <>
      <Menu>
        <MenuButton
          as={Button}
          size="sm"
          h={7}
          variant="outline"
          colorScheme="gray"
          rightIcon={<Icon as={FiChevronDown} boxSize={3} />}
          minW="160px"
          textAlign="left"
        >
          <HStack spacing={2}>
            <Icon as={selected.icon} boxSize={3.5} />
            <Text fontSize="sm" fontWeight="medium">{selected.label}</Text>
          </HStack>
        </MenuButton>
        <MenuList minW="160px" py={1} shadow="md">
          {SENDER_OPTIONS.map((option) => (
            <MenuItem
              key={option.value}
              icon={<Icon as={option.icon} boxSize={3.5} />}
              onClick={() => onChange(option.value)}
              isDisabled={option.value === "me" && !isAuthorized}
              fontSize="sm"
              py={1.5}
            >
              {option.label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
      {!isAuthorized && (
        <Text fontSize="xs" color="gray.500" mt={1}>
          Want to send as yourself?
          {" "}
          <InternalLink to={SHARED_ROUTES.individualSettings} target="_blank" color="cdsIndigo.500">
            Connect Slack
          </InternalLink>
        </Text>
      )}
    </>
  );
}
